module.exports = __webpack_public_path__ + "static/avatar_konstantin_malasaev-82be15b29c259b13f4402dbeac6570af.jpg";